export default __webpack_public_path__ + "static/media/macTech3.85930765.png";